import { getColorsByType, type PreviewCardType } from './helpers/getColorsByType'
import type { PreviewCardProps } from './types'

import * as S from './styles'

export const PreviewCard = ({
  label,
  value,
  percentage,
  description,
  icon,
  infoIcon,
  cardType = 'budget',
  isNegative = false,
  previewWeek
}: PreviewCardProps) => {
  const colors = getColorsByType(cardType as PreviewCardType, isNegative, previewWeek)
  return (
    <S.Container
      style={{
        borderTopColor: colors.borderColor
      }}
    >
      <S.LeftBox>
        <S.Label>
          {label}
          {!!infoIcon && infoIcon}
        </S.Label>

        <S.Value
          style={{
            color: colors.text
          }}
        >
          {value}
        </S.Value>

        <S.BottomBox>
          <S.Percentage
            style={{
              color: colors.text
            }}
          >
            {percentage}
          </S.Percentage>
          <S.Description
            style={{
              color: colors.descriptionColor
            }}
          >
            {description}
          </S.Description>
        </S.BottomBox>
      </S.LeftBox>

      <S.IconBox
        style={{
          color: colors.color,
          background: colors.background
        }}
      >
        {icon}
      </S.IconBox>
    </S.Container>
  )
}
